import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

import rootReducer, { initial_state } from "./reducers";

import rootSaga from "./sagas";

export default function(initialState = initial_state) {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = composeWithDevTools(applyMiddleware(sagaMiddleware));

  const store = createStore(rootReducer, initialState, middlewares);

  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/store.js